<i18n>
{
"en": {
  "INCIDENTS": "Incidents",
  "STUDENTSINVOLVED": "Students Involved",
  "OPEN": "Open",
  "REPORTTO": "Report to",
  "POLICE": "Police",
  "BUSCOMPANY": "Bus Company",
  "RE-OPEN": "Re-open",
  "RESOLVED": "Resolved",
  "MARKRESOLVED": "Mark Resolved",
  "MESSAGE": "Message",
  "SUPERVISORMOBILE": "Supervisor Mobile",
  "INCIDENTTYPE": "Incident Type",
  "VIEWIMAGE": "View Image",
  "SHOWMAP": "Show Map",
  "VIEWINCIDENTDETAILS": "View Incident Details",
  "SELECTMONITOR": "Select Monitor",
  "ROUTE": "Route:",
  "NOSTUDENTSINVOLVED": "No students involved",
  "BUSNUMBER": "Bus Number",
  "MESSAGEH": "Message:",
  "NOMESSAGE": "No Message",
  "RESOLUTION": "Resolution",
  "WRITEYOURMESSAGE": "Write your message",
  "CLOSE": "Close",
  "SAVE": "Save",
  "SENDING": "Sending...",
  "SENDMESSAGE": "Send Message",
  "REPORTINCIDENTTO": "Report incident to",
  "PARENTS": "Parents",
  "CANCEL": "Cancel",
  "INCIDENTIMAGE": "Incident Image",
  "CHILDBEHAVIOUR": "Child Behaviour",
  "MEDICAL": "Medical",
  "DRIVERISSUE": "Driver Issue",
  "BUSPROBLEM": "Bus Problem",
  "ACCIDENT": "Accident",
  "TRAFFIC": "Traffic",
  "CALLPOLICE": "Call Police",
  "CALLSCHOOL": "Call School",
  "OTHER": "Other",
  "EMAILHASSENT": "Email has been sent!",
  "EMAILHASNOTSEND": "Email has not send!",
  "SUCCESS": "Message has been sent!",
  "FAILED": "Failed to send!",
  "MISSEDALERT": "Storage error @3 on disk @1",
  "DELAYED": "Delayed",
  "DURATION": "Duration",
  "STANDING": "Standing",
  "MISSED": "Missed",
  "WRONGPLACE": "Wrong Place",
  "PRINTINCIDENT": "Print Incident"
},
"ar": {
  "INCIDENTS": "احداث",
  "STUDENTSINVOLVED": "الطلاب المعنيين",
  "OPEN": "مفتوحة",
  "REPORTTO": "تقرير الى",
  "POLICE": "شرطة",
  "BUSCOMPANY": "شركة الباصات",
  "RE-OPEN": "إعادة فتح",
  "RESOLVED": "حل",
  "MARKRESOLVED": "أمر محسوم",
  "MESSAGE": "رسالة",
  "SUPERVISORMOBILE":"رقم جوال المشرفة",
  "INCIDENTTYPE": "نوع الحادث",
  "VIEWIMAGE": "عرض الصورة",
  "SHOWMAP": "عرض الخريطة",
  "VIEWINCIDENTDETAILS": "عرض تفاصيل الحوادث",
  "SELECTMONITOR": "حدد المشرفة",
  "ROUTE": "طريق",
  "NOSTUDENTSINVOLVED": "لا طلاب متورطين",
  "BUSNUMBER": "رقم الحافلة",
  "MESSAGEH": "رسالة",
  "RESOLUTION": "القرار",
  "WRITEYOURMESSAGE": "اكتب رسالتك",
  "CLOSE": "أغلق",
  "SAVE": "حفظ",
  "SENDING": "إرسال",
  "SENDMESSAGE": "أرسل الرسالة",
  "REPORTINCIDENTTO": "تبليغ الحادث إلى",
  "PARENTS": "الآباء",
  "CANCEL": "الغاء",
  "INCIDENTIMAGE": "صورة الحادث",
  "CHILDBEHAVIOUR": "سلوك الطفل",
  "MEDICAL": " طبي",
  "DRIVERISSUE": "مشكلة السائق",
  "BUSPROBLEM": "مشكلة الحافلة",
  "ACCIDENT": "حادث",
  "TRAFFIC": "حركة المرور",
  "CALLPOLICE": "اتصل بالشرطة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "OTHER": "الأخرى",
  "EMAILHASSENT": "تم ارسال البريد الالكتروني!",
  "EMAILHASNOTSEND": "لم يرسل البريد الإلكتروني!",
  "SUCCESS": "تم ارسال الرسالة!",
  "FAILED": "فشل فى الارسال!",
  "DELAYED": "مؤجل",
  "DURATION": "المدة الزمنية",
  "STANDING": "واقفا",
  "MISSED": "مفقود",
  "WRONGPLACE": "المكان الخطأ",
  "PRINTINCIDENT": "طباعة حادثة"
}
}
</i18n>
<template>
  <div id="incidentDialog" ref="printIncident" @click.stop="1">
    <el-dialog class="incident_dialog" v-if="dialogVisible" :show-close="false" :visible.sync="dialogVisible" size="tiny">
          <span class="el-dialog__title" slot="title" v-text="$t('ROUTE') + ' '+ incident.TourName"></span>
          <el-button type="text" class="el-dialog__headerbtn" @click="deleteIncident" slot="title"><i class="el-dialog__close el-icon-close"></i></el-button>
          <el-dropdown slot="title" class="el-dialog__headerbtn" @command="printIncident">
              <el-button  type="text" style="padding: 0px"><i class="el-dialog__close el-icon-more rotate-90"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><i class="fa fa-print"></i> {{$t('PRINTINCIDENT')}}</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
        <el-row>
        <div
            id="gmap-incident"
            ref="gmap"
            style="width: 100%; height: 300px"> 
        </div>
        <el-row v-show="false" :gutter="10" ref="student">
          <div v-if="total == 0">{{$t('NOSTUDENTSINVOLVED')}}</div>
          <el-col :span="24/total" :key="index" v-for="(student, index) in incident.students"  v-if="total != 0">
            <img :src="getAsset(student.ImagePath, 'student')" class="img-circle" style="width:50px"><br/>
            {{_FullName({NameEN: student.FullName_EN, NameAR: student.FullName_AR})}}
          </el-col>
        </el-row>        
        </el-row>
        <el-row style="padding: 10px 0">
            <el-col :span="8" align="center">
            <b><i class="fa fa-exclamation-triangle"></i> {{alert ? 'Alert Type' : $t('INCIDENTTYPE')}}</b> <span style="display: block; height:10px"></span>  {{$t(incident.incident_type)}}
            </el-col>
            <el-col :span="8"  align="center">
            <b><i class="fa fa-bus"></i> {{$t('BUSNUMBER')}}</b> <span style="display: block; height:10px"></span>    <el-tag>{{incident.bus.Label}}</el-tag>
            </el-col>
            <el-col :span="8"  align="center">
            <b><i class="fa fa-phone"></i> {{$t('SUPERVISORMOBILE')}}</b> <span style="display: block; height:10px"></span>   {{incident.monitor.MobilePhone}}
            </el-col>
        </el-row>
        <el-row style="padding: 10px">
        <b v-if="!alert">{{$t('MESSAGEH')}} </b><span v-text="incident.Text !== null ? incident.Text : $t('NOMESSAGE')">{{$t('MESSAGE')}}</span>
        </el-row>

        <span slot="footer" v-if="isAllowed('save', 'report/incident') && !alert">
            <el-popover
            trigger="manual"
            placement="top"
            width="300"
            v-model="popperVisible">
                <h3>{{$t('RESOLUTION')}}</h3>
                <el-input
                        type="textarea"
                        :maxlength="256"
                        :rows="4"
                        v-model="message.Text"
                        :placeholder="$t('WRITEYOURMESSAGE')"
                        >
                </el-input>                 
                <div style="text-align: right; margin: 5px">
                    <el-button size="mini" @click="popperVisible=false">{{$t('CLOSE')}}</el-button>                   
                    <el-button :disabled="message.Text==''" type="primary" size="mini" @click="markResolved">{{$t('SAVE')}}</el-button>                    
                </div>
               <el-button-group  slot="reference">            
                <el-button :disabled="incident.statusColor==0" :type="incident.statusColor==0 ? 'success' : ''" @click="popperVisible = true"><i class="fa" :class="[incident.statusColor!=0 ? 'fa-square-o' : 'fa-check-square']"></i> {{' ' + incident.statusColor==0 ? $t('RESOLVED') : $t('MARKRESOLVED')}}</el-button>
                <el-button :type="incident.statusColor==0 ? 'warning' : 'primary'"  @click="reportIncident"><i :class="[incident.statusColor==0 ? 'fa fa-undo ' : '']"></i> {{' ' + incident.statusColor==0 ? $t('RE-OPEN') : $t('REPORTTO')}}</el-button>
            </el-button-group>
           </el-popover>            
           <el-button v-if="incident.ImagePath" icon="picture" style="float:left" @click="imageVisible = true">{{$t('VIEWIMAGE')}}</el-button>
      
        </span>
    </el-dialog>
    <el-dialog :title="$t('REPORTINCIDENTTO')" :visible.sync="sendReport" size="tiny">
        <span>
            <el-radio-group v-model="message.Recipient">
                <el-radio-button :label="6" v-if="hideParentsOption()">{{$t('PARENTS')}}</el-radio-button>
                <el-radio-button :label="7">{{$t('POLICE')}}</el-radio-button>
                <el-radio-button :label="8">{{$t('BUSCOMPANY')}}</el-radio-button>
            </el-radio-group>
        <div style="margin: 20px 0;"></div>
        <el-input
            type="textarea"
            :rows="4"
            :placeholder="$t('WRITEYOURMESSAGE')"
            v-model="message.Text">
            </el-input>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="sendReport = false">{{$t('CANCEL')}}</el-button>
            <el-button :disabled="message.Text=='' || message.Recipient==null" type="primary" :loading="loadingSend" @click="reportTo"> {{loadingSend ? $t('SENDING') : $t('SENDMESSAGE')}}</el-button>
        </span>
    </el-dialog>
    <el-dialog v-if="imageVisible" size="tiny" :title="$t('INCIDENTIMAGE')" :visible.sync="imageVisible">
      <div align="center">
        <img  :src="getAsset(incident.ImagePath, 'incident')" style="width:100%">
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="imageVisible = false">{{$t('CLOSE')}}</el-button>
      </span>
  </el-dialog>     
  </div>  
</template>

<script>
  
  import _ from 'lodash'
  export default {
    name: 'ElIncidentDialog',
    componentName: 'ElIncidentDialog',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      incident: {
        type: Object,
        default: function () {
          return {incident_type: null, bus: {}, monitor: {}, Lat: null, Lng: null}
        }
      },
      alert: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      dialogVisible () {
        this.$emit('update:visible', this.dialogVisible)
      },
      visible () {
        this.switchLanguage()
        if (this.visible) this.loadIncident()
      }
    },
    data () {
      return {
        dialogVisible: false,
        sendReport: false,
        popperVisible: false,
        loadingSend: false,
        message: {Recipient: null, RecipientID: 0, hasAttachment: false, Text: ''},
        center: {lat: 0, lng: 0},
        school: {lat: 0, lng: 0},
        marker: {lat: 0, lng: 0, icon: {url: require('../../assets/img/map/school.png')}},
        maps: null,
        map: null,
        total: 0,
        imageVisible: false
      }
    },
    methods: {
      loadIncident () {
        let userData = JSON.parse(localStorage.getItem('userData'))
        this.school = this.center = {lat: userData.school_location.Lat, lng: userData.school_location.Lng}
        this.getIncident()
      },
      sendIncidentReport () {
        this.sendReport = false
        this.incident.statusColor = 1
      },
      markResolved () {
        let status = ''
        if (this.incident.statusColor === 0) status = 'Reopen'
        this.resolve(status)
      },
      loadMap () {
        let self = this
        self.dialogVisible = self.visible
        this.$google.then(function (Maps) {
          console.log('LOADED')
          self.maps = Maps
          self.map = new Maps.Map(document.getElementById('gmap-incident'), {
            center: self.center,
            zoom: 15
          })
          if (self.incident.Lat === null) return
          let position = new Maps.LatLng(parseFloat(self.incident.Lat), parseFloat(self.incident.Lng))
          let infoWindow = new Maps.InfoWindow()
          infoWindow.setContent(self.$refs.student.$el.innerHTML)
          let marker = new Maps.Marker({
            position: position,
            icon: {
              path: 'M0-48c-9.8 0-15.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
              fillColor: 'red',
              fillOpacity: 1,
              strokeColor: 'red'
            },
            map: self.map
          })
          self.map.setCenter(position)
          Maps.event.addListener(marker, 'click', function () {
            infoWindow.open(self.map, marker)
          })
          Maps.event.addListenerOnce(self.map, 'tilesloaded', function () {
            infoWindow.open(self.map, marker)
          })
        })
      },
      getIncident () {
        this.total = this.incident.students.length
        let students = this.incident.student_id
        if (this.total > 0 || students.length === 0) return this.loadMap()
        let self = this
        let promises = []
        for (let student in students) {
          let StudentID = this.incident.student_id[student]
          promises.push(this.getStudent(StudentID))
        }
        Promise.all(promises).then(function (results) {
          for (let result in results) {
            let data = results[result].data
            if (data.student !== null) {
              self.incident.students.push(data.student)
            }
          }
          self.total = self.incident.students.length
        }).then(function () {
          self.loadMap()
        })
      },
      getStudent (StudentID) {
        return this.$http.get('/student/' + StudentID)
      },
      reportIncident () {
        this.message.Text = ''
        if (this.incident.statusColor === 0) {
          this.popperVisible = true
        } else this.sendReport = true
      },
      resolve (to) {
        let status = 0
        let self = this
        if (!_.isEmpty(to)) status = 1
        if (to === 'Reopen') status = 2
        let postData = {IncidentID: this.incident.incident_id, status: this.incident.statusColor, IncidentStatus: status}
        this.$http.post('/incident/status', postData).then(function (response) {
          self.incident.status = response.data.status
          self.incident.statusColor = response.data.statusColor
          self.popperVisible = false
          self.$message({
            message: to !== 'Reopen' ? self.$t('RESOLVED') : self.$t('RE-OPENED'),
            type: 'success',
            showClose: true
          })
        }).catch(function () {
        })
      },
      deleteIncident () {
        this.$emit('deleteIncident', {statusColor: this.incident.statusColor, show: !this.incident.IsSticky})
        this.dialogVisible = false
      },
      reportTo () {
        let self = this
        self.loadingSend = true
        switch (this.message.Recipient) {
          case 6:
            this.message.RecipientID = this.incident.student_id
            break
          case 7:
          case 8:
            this.message.incident = this.incident
            break
        }
        let postData = {message: this.message}
        this.$http.post('/message/send', postData).then(function (response) {
          self.$message({
            message: self.$t(response.data.message),
            type: response.data.error ? 'error' : 'success',
            showClose: true
          })
          self.loadingSend = false
          if (!response.data.error) {
            setTimeout(function () {
              self.sendReport = false
            }, 1500)
          }
        }).catch(function () {
        })
      },
      hideParentsOption () {
        if (this.incident.student_id === undefined) return
        if (this.incident.student_id.length > 0) return true
        return false
      },
      printIncident () {
        this.$nextTick(function () {
          let card = this.$refs.printIncident.innerHTML
          let w = window.open()
          w.document.write('<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>Print it!</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/element-ui/1.4.9/theme-default/index.css"><style> @media print {.gm-style .gmnoprint:not(img), .gmnoprint:not(img){display: none;}}@media screen{.gm-style .gmnoscreen, .gmnoscreen {display:none}}@media print{body{-webkit-print-color-adjust: exact;}} .el-dialog--tiny{width: 60%;} .img-circle{width: 50px;float: left;margin-right: 10px;border-radius: 50%;} .el-dialog__body{padding:15px 0} .el-dialog__footer, .el-dialog__header button{display: none;}</style></head><body>')
          let s = w.document.createElement('script')
          s.type = 'text/javascript'
          s.src = require('../../assets/js/print.js')
          w.document.write(card)
          w.document.body.appendChild(s)
          w.document.write('</body></html>')
          w.setTimeout(function () {
            w.print()
            w.close()
          }, 1000)
        })
      }
    }
  }
</script>
<style>
    #incidentDialog .incident_dialog .el-dialog__body{padding:15px 0}
    .rotate-90 {
      -webkit-transform: rotate(90deg);
      -moz-transform: rotate(90deg);
      -o-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
    }
    #incidentDialog .el-dialog__header button {padding-top: 2px;margin-left: 10px;}
    #rtl #incidentDialog .el-dialog__header button {padding-top: 2px;margin-left:0px;margin-right: 10px;}
</style>



// WEBPACK FOOTER //
// Incident.vue?4e60d01f